import { EventListener, RegistryInterface } from "silver";
import { Expander, ExpanderChangeEvent } from "shared/Components/Expander";

export class ExpanderService {

	public readonly onChange = EventListener.create<ExpanderChangeEvent>("change");

	private registry: Record<string, Expander> = { };

	constructor(
		private userStorage: RegistryInterface<boolean>
	) { }

	makeStandard(source: HTMLElement, target: HTMLElement, name: string): Expander {
		const cacheKey = "filter-open:" + name;
		const expander = new Expander(source, target, {
			sourceOpenClass: "-checked",
			targetOpenClass: "-visible"
		});
		expander.onChange(({ open }) => this.userStorage.set(cacheKey, open));
		if (this.registry.hasOwnProperty(name)) {
			console.warn(`Duplicate name ${name} in registry`);
		}
		this.registry[name] = expander;

		if (!this.userStorage.get(cacheKey)) {
			expander.open = false;
		} else {
			target.classList.add("g_noTransition");
			expander.open = this.userStorage.get(cacheKey) ?? false;
			setTimeout(function() {
				target.classList.remove("g_noTransition");
			});
		}

		return expander;
	}
}
